module.exports = __webpack_public_path__ + "img/img_16.68459839.png";